import script from "./team.vue?vue&type=script&setup=true&lang=js"
export * from "./team.vue?vue&type=script&setup=true&lang=js"

import "./team.vue?vue&type=style&index=0&id=6ff40467&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff40467"]])

export default __exports__